module.exports = __webpack_public_path__ + "static/media/NFSB05.707d10de.jpg";